import { render, staticRenderFns } from "./PieAmchart.vue?vue&type=template&id=549c08ea&scoped=true&"
import script from "./PieAmchart.vue?vue&type=script&lang=js&"
export * from "./PieAmchart.vue?vue&type=script&lang=js&"
import style0 from "./PieAmchart.vue?vue&type=style&index=0&id=549c08ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549c08ea",
  null
  
)

export default component.exports